import { getWebAppLink, getGuestSiteLink, getNetworkLink, getSamplesLink } from '@landr/core';
import { useMemo } from 'react';
import { PricingTabs, Links, GuestSitePricingLinks, GuestSitePricingTabs } from '../../../enums/Links.es.js';
import { useNavBarContext } from '../../../contexts/NavBarProvider/NavBarContext.es.js';
import { useNavBarLocation } from '../../../contexts/NavBarProvider/NavBarProvider.es.js';
import { Languages } from '../../../enums/languages.es.js';

var getPricingParams = function getPricingParams(returnUrl) {
  return "returnUrl=".concat(encodeURIComponent(returnUrl));
};
var getPricingParamsByPathMapping = function getPricingParamsByPathMapping(pathname) {
  return {
    '/library': "".concat(Links.PricingMastering, "?").concat(getPricingParams(pathname)),
    '/releases': "".concat(Links.PricingDistribution, "?").concat(getPricingParams(pathname)),
    '/sessions': "".concat(Links.PricingSessions, "?").concat(getPricingParams(pathname)),
    '/projects': "".concat(Links.Pricing, "?").concat(getPricingParams(pathname))
  };
};
var getWebAppPricingParamsByHostMapping = function getWebAppPricingParamsByHostMapping(env, pathname) {
  var isSamplesInWebApp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    network: "".concat(Links.Pricing, "?").concat(getPricingParams(getNetworkLink(env, pathname))),
    samples: "".concat(Links.PricingSamples, "?").concat(getPricingParams(getSamplesLink(env, pathname, {
      isSamplesInWebApp: isSamplesInWebApp
    })))
  };
};
function getWebAppPricingLink(env, location) {
  var _Object$keys$find, _paramsMapping$match;
  var samplesInWebApp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var paramsMapping = getWebAppPricingParamsByHostMapping(env, location.pathname, samplesInWebApp);
  var pricingParamsByPathMapping = getPricingParamsByPathMapping(location.pathname);
  var match = (_Object$keys$find = Object.keys(paramsMapping).find(function (host) {
    return location.host.startsWith(host);
  })) !== null && _Object$keys$find !== void 0 ? _Object$keys$find : '';
  if (!match) {
    var _Object$keys$find2;
    match = (_Object$keys$find2 = Object.keys(pricingParamsByPathMapping).find(function (appPath) {
      return location.pathname.startsWith(appPath);
    })) !== null && _Object$keys$find2 !== void 0 ? _Object$keys$find2 : '';
    paramsMapping = pricingParamsByPathMapping;
  }
  return getWebAppLink(env, (_paramsMapping$match = paramsMapping[match]) !== null && _paramsMapping$match !== void 0 ? _paramsMapping$match : Links.Pricing);
}
var GuestSitePricingTabByHostMapping = {
  samples: PricingTabs.Samples
};
var GuestSitePricingTabByPathMapping = {
  '/library': PricingTabs.Mastering,
  '/releases': PricingTabs.Distribution,
  '/sessions': PricingTabs.Sessions
};
function getGuestSitePricingTab(location) {
  var hostMatch = Object.keys(GuestSitePricingTabByHostMapping).find(function (host) {
    return location.host.startsWith(host);
  });
  if (hostMatch) {
    return GuestSitePricingTabByHostMapping[hostMatch];
  }
  var pathMatch = Object.keys(GuestSitePricingTabByPathMapping).find(function (appPath) {
    return location.pathname.startsWith(appPath);
  });
  return pathMatch ? GuestSitePricingTabByPathMapping[pathMatch] : null;
}
function getGuestSitePricingLink(env, language, location) {
  var pricingTab = getGuestSitePricingTab(location);
  if (!GuestSitePricingLinks[language]) {
    // Default to english in case the language is undefined
    language = Languages.English;
  }
  var pricingLink = GuestSitePricingLinks[language];
  if (pricingTab) {
    pricingLink += GuestSitePricingTabs[language][pricingTab];
  }
  return getGuestSiteLink(env, pricingLink);
}
function usePricingLink() {
  var _useNavBarContext = useNavBarContext(),
    env = _useNavBarContext.env,
    user = _useNavBarContext.user,
    language = _useNavBarContext.language,
    features = _useNavBarContext.features;
  var location = useNavBarLocation();
  return useMemo(function () {
    return user ? getWebAppPricingLink(env, location, features.hasSamplesInWebApp) : getGuestSitePricingLink(env, language, location);
  }, [location, env, language, user, features.hasSamplesInWebApp]);
}

export { usePricingLink };
